import { render, staticRenderFns } from "./PBX.vue?vue&type=template&id=ee705dfa&scoped=true"
import script from "./PBX.vue?vue&type=script&lang=js"
export * from "./PBX.vue?vue&type=script&lang=js"
import style0 from "./PBX.vue?vue&type=style&index=0&id=ee705dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee705dfa",
  null
  
)

export default component.exports